import { messages } from '../../config/messages';
export const REDUCER_NAME = "dealOfTheDaySlice";

export interface iDealOfTheDayDTO {
  title: string;
  product_id: string;
  status?: boolean;
}

export interface iDealOfTheDayResponse {
  id: string;
  title: string;
  product_id: string;
  product_name: string;
  product_image: string;
 product_price: number;
  status: boolean;
  created_at: string;
  updated_at: string;
}

export interface iDealOfTheDayState {
  isLoading: boolean;
  dealList: iDealOfTheDayResponse[];
  errorMessage: string | null;
}
export interface iMessageResponseType{
    messages: string;
}